import * as React from "react";
import * as Modal from "react-modal";
import { MoodboardSelectionCard } from "./MoodboardSelectionCard";
import { useState } from "react";
export var MoodboardSelectionModal = function () {
    var _a = useState(true), isOpen = _a[0], setIsOpen = _a[1];
    function close() {
        setIsOpen(false);
    }
    return (React.createElement(Modal, { isOpen: isOpen, onRequestClose: close, className: "moodboard-selection-modal tds", overlayClassName: "moodboard-selection-modal-overlay" },
        React.createElement("div", { className: "close-btn-wrapper text-right" },
            React.createElement("i", { className: "iconoir-xmark cursor-pointer close-btn", onClick: close })),
        React.createElement(MoodboardSelectionCard, { onSelected: close })));
};
